export default __webpack_public_path__ + "static/media/logo_financiero.52cce368.svg";